import { PROJECT_TYPE } from './const';
import {
  BRIEF_TYPE,
  contentTypeFromBriefType,
  isManualBriefType,
  isExtractingBriefType,
} from '../brief';
import { CONTENT_TYPE } from '../contentType';

const PRODUCT_BRIEF_TYPES = [BRIEF_TYPE.unifiedProduct];
const CONTENT_BRIEF_TYPES = [BRIEF_TYPE.unifiedContent];
const SOCIAL_BRIEF_TYPES = [BRIEF_TYPE.socialManual];

const PRODUCT_AND_CONTENT_BRIEF_TYPES = [...PRODUCT_BRIEF_TYPES, ...CONTENT_BRIEF_TYPES];

const PROJECT_BRIEF_TYPES_ASSOCIATION = {
  [PROJECT_TYPE.facebookAd]: PRODUCT_AND_CONTENT_BRIEF_TYPES,
  [PROJECT_TYPE.googleAd]: PRODUCT_BRIEF_TYPES,
  [PROJECT_TYPE.taboolaAd]: PRODUCT_AND_CONTENT_BRIEF_TYPES,
  [PROJECT_TYPE.outbrainAd]: PRODUCT_AND_CONTENT_BRIEF_TYPES,
  [PROJECT_TYPE.linkedinAd]: PRODUCT_AND_CONTENT_BRIEF_TYPES,
  [PROJECT_TYPE.twitterAd]: PRODUCT_AND_CONTENT_BRIEF_TYPES,
  [PROJECT_TYPE.pinterestAd]: PRODUCT_AND_CONTENT_BRIEF_TYPES,
  [PROJECT_TYPE.teadsSingleImage]: PRODUCT_BRIEF_TYPES,
  [PROJECT_TYPE.teadsSingleVideo]: PRODUCT_BRIEF_TYPES,
  [PROJECT_TYPE.teadsCarousel]: PRODUCT_BRIEF_TYPES,
  [PROJECT_TYPE.teadsSocialLayout1]: PRODUCT_BRIEF_TYPES,
  [PROJECT_TYPE.teadsSocialLayout1]: PRODUCT_BRIEF_TYPES,
  [PROJECT_TYPE.teadsSocialLayout2]: PRODUCT_BRIEF_TYPES,

  [PROJECT_TYPE.continuousOptimization]: [BRIEF_TYPE.unifiedProduct],
  [PROJECT_TYPE.wtmHomePage]: [BRIEF_TYPE.unifiedProduct],
  [PROJECT_TYPE.seoMetaDescription]: PRODUCT_BRIEF_TYPES,

  [PROJECT_TYPE.productDescription]: [BRIEF_TYPE.unifiedProduct],
  [PROJECT_TYPE.shopifyProductsDescription]: [BRIEF_TYPE.shopifyProductBrief],
  [PROJECT_TYPE.amazonProductDescription]: [BRIEF_TYPE.unifiedProduct],
  [PROJECT_TYPE.walmartProductListing]: [BRIEF_TYPE.unifiedProduct],
  [PROJECT_TYPE.featuresToBenefits]: [BRIEF_TYPE.unifiedProduct],

  [PROJECT_TYPE.facebookSocial]: SOCIAL_BRIEF_TYPES,
  [PROJECT_TYPE.instagramSocial]: SOCIAL_BRIEF_TYPES,
  [PROJECT_TYPE.twitterSocial]: SOCIAL_BRIEF_TYPES,
  [PROJECT_TYPE.linkedinSocial]: SOCIAL_BRIEF_TYPES,
  [PROJECT_TYPE.pinterestSocial]: SOCIAL_BRIEF_TYPES,
  [PROJECT_TYPE.youtubeSocial]: SOCIAL_BRIEF_TYPES,

  [PROJECT_TYPE.blogPostBuilder]: [BRIEF_TYPE.blogPostBuilder],
  [PROJECT_TYPE.sms]: PRODUCT_BRIEF_TYPES,
  [PROJECT_TYPE.emailSubjectLine]: [BRIEF_TYPE.email],
  [PROJECT_TYPE.emailColdOutreach]: PRODUCT_BRIEF_TYPES,
  [PROJECT_TYPE.emailPromotional]: [BRIEF_TYPE.unifiedPromotionalEmail],
  [PROJECT_TYPE.landingPageBuilder]: [BRIEF_TYPE.unifiedProduct],

  [PROJECT_TYPE.canvas]: [BRIEF_TYPE.canvas],
  [PROJECT_TYPE.document]: [BRIEF_TYPE.unifiedProduct],
};

export const getBriefTypesSupportedByProjectType = (projectType) =>
  PROJECT_BRIEF_TYPES_ASSOCIATION[projectType] || [];

export const isProjectTypeSupportsBriefType = (projectType, briefType) => {
  const supportedBriefTypes = PROJECT_BRIEF_TYPES_ASSOCIATION[projectType] || [];
  return supportedBriefTypes.includes(briefType);
};

export const getInitialBriefTypeForProjectType = (projectType) => {
  const briefTypes = getBriefTypesSupportedByProjectType(projectType);
  return briefTypes[0];
};

export const doesProjectTypeSupportSeveralBriefTypes = (projectType) => {
  const briefTypes = getBriefTypesSupportedByProjectType(projectType);
  return briefTypes.length > 1;
};

const contentTypePresentInBriefTypes = (briefTypes, contentType) =>
  briefTypes.map(contentTypeFromBriefType).some((_contentType) => _contentType === contentType);

export const projectTypeSupportsContent = (projectType) => {
  const briefTypes = getBriefTypesSupportedByProjectType(projectType);
  return contentTypePresentInBriefTypes(briefTypes, CONTENT_TYPE.content);
};

export const projectTypeSupportsProduct = (projectType) => {
  const briefTypes = getBriefTypesSupportedByProjectType(projectType);
  return contentTypePresentInBriefTypes(briefTypes, CONTENT_TYPE.product);
};

export const projectTypeSupportsUrlBrief = (projectType) => {
  // HINT: was added as a workaround for https://keywee.slack.com/archives/CFKBG7YM6/p1650463298546979 on 2022-04-20
  if (projectType === PROJECT_TYPE.walmartProductListing) {
    return false;
  }

  const briefTypes = getBriefTypesSupportedByProjectType(projectType);
  return briefTypes.some(isExtractingBriefType);
};

export const projectTypeSupportsManualBrief = (projectType) => {
  const briefTypes = getBriefTypesSupportedByProjectType(projectType);
  return briefTypes.some(isManualBriefType);
};

export const projectTypeSupportPromotionField = (projectType) => {
  return [PROJECT_TYPE.emailPromotional].includes(projectType);
};

export const isContentBrief = (brief) => CONTENT_BRIEF_TYPES.includes(brief.type);
